<template>
  <!-- mega drop down -->
  <div
    class="wp_HeaderCategoryNav"
    id="wp_CategoryNav"
  >
    <div class="container wp_headerContainer">
      <div class="wp_newCategoryNav">
        <nav
          id="category-nav-bar"
          class="main-nav"
          @mouseover="enableHover()"
        >
          <div
            class="collapse navbar-collapse position-relative"
            id="navbarSupportedContent"
          >
            <div class="row d-flex d-lg-none">
              <div class="brand-2 col">
                <a href
																			data-test="categoryNavBarLink1">
                  <img
                    src="@/assets/img/neobank.png"
                    alt="Site Logo"
                    id="logo-img"
																				data-test="categoryNavBarImg1"
                  />
                </a>
              </div>
              <div class="close-btn col">
                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  id="navbar-close"
																		data-test="categoryNavBarBtn1"
                >
                  <div class="icon icon--ei-close icon--s">
                    <img
                      class="icon_cnt"
                      src="@/assets/svg/ei-close.svg"
                      alt="Close Icon"
                      srcset
                      id="navbar-close-icon"
																						data-test="categoryNavBarImg2"
                    />
                  </div>
                </button>
              </div>
            </div>

            <ul class="nabarul">
              <ul @click="hideCategoryNavBar()"
																		data-test="categoryNavBarLink2">
                <main-nav-tab-template
                  v-for="(tabData, index) in getCategoryData"
                  :key="index"
                  :tabData="tabData"
                  :index="index"
                ></main-nav-tab-template>
              </ul>

              <li class="nav-item dropdown d-block d-md-none">
                <!--<a href="" @click.prevent="orderMobile"></a>-->
                <router-link
                  to="/user/orders"
                  class="nav-link dropdown-toggle"
                  id="navbarDropdown"
                  tag="a"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
																		data-test="categoryNavBarLink3"
                >Orders</router-link>
              </li>
              <li class="nav-item dropdown d-block d-md-none">
                <!--<a href="" @click.prevent="wishListMobile"></a>-->
                <router-link
                  to="/user/wish-list"
                  class="nav-link dropdown-toggle"
                  id="navbarDropdown1"
                  tag="a"
                  aria-haspopup="true"
                  aria-expanded="false"
																		data-test="categoryNavBarLink4"
                >Wishlist</router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavTabTemplate from '@/components/shared/categoryNavBar/widgets/MainTabTemplate'
import { mapGetters } from 'vuex'

export default {
	components: {
		MainNavTabTemplate
	},
	computed: {
		...mapGetters('category', ['getCategoryData'])
	},
	methods: {
		enableHover () {
			/* .active on #category-nav-bar disables its hover effect */
			if ($('#category-nav-bar').hasClass('active')) {
				$('#category-nav-bar').removeClass('active')
			}
		},
		hideCategoryNavBar () {
			if (!$('#category-nav-bar').hasClass('active')) {
				$('#category-nav-bar').addClass('active')
			}
		}
	}
}
</script>
